<script setup>
import Nudge from './Nudge.vue'
const props = defineProps({
  location: String,
  availableCarsCount: Number,
  carsMinTotal: Number,
  visibleCarsCount: Number,
  suggestedExtensionDiscount: Number,
  secureForFeeData: Object,
  isWeekendBooking: Boolean,
})

const occupancyPercents = props.visibleCarsCount >= 20
    ? Math.round((props.visibleCarsCount - props.availableCarsCount) * 100 / props.visibleCarsCount)
    : 0

const showOccupancy = occupancyPercents >= 65
const showConsecutiveDiscount = !!props.suggestedExtensionDiscount
const showSecureForFeePercents = !(showOccupancy && showConsecutiveDiscount) && (props.secureForFeeData && props.carsMinTotal >= props.secureForFeeData.min_total) && !window.disableBookingCustomItems
const showWorkDays = (+showOccupancy + +showConsecutiveDiscount + +showSecureForFeePercents < 2) && props.isWeekendBooking
</script>

<template>
  <!-- Occupancy -->
  <Nudge
    v-if="showOccupancy"
    :text="$t('layout.nudges.occupancy_rate', { percents: occupancyPercents, location })"
    bg-color="#FEF5E0"
    color="#F18A10"
    icon="occupancy.svg"
    icon-alt="occupancy"
  />

  <!-- Consecutive discount -->
  <Nudge
    v-if="showConsecutiveDiscount"
    :text="$t('layout.nudges.consecutive_discount', { discount: suggestedExtensionDiscount })"
    bg-color="#DDFAD9"
    color="#36A824"
    icon="consecutive-discount.svg"
    icon-alt="consecutive discount"
  />

  <!-- Secure for fee -->
  <Nudge
    v-if="showSecureForFeePercents"
    :text="$t('layout.nudges.secure_for_fee', { percents: secureForFeeData.percents })"
    bg-color="#F1F3FA"
    color="#17275B"
    icon="secure-for-fee.svg"
    icon-alt="secure for a small fee"
  />

  <!-- Work days -->
  <Nudge
    v-if="showWorkDays"
    :text="$t('layout.nudges.work_days')"
    bg-color="#DDFAD9"
    color="#36A824"
    icon="work-days.svg"
    icon-alt="work days"
  />
</template>

<style scoped>

</style>
